// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    margin: 0px;
    height: 100vh;
}

body {
    background-color: var(--background);
    display: flex;
    flex-direction: column;
    color: var(--text);
}

.title-bar {
    background-color: var(--tiles);
    color:var(--primary);
    font-family: 'Montserrat', sans-serif;
    font-size:3rem;
    padding: 1rem;
    justify-items: center;
    text-align: center;
    font-weight: bolder;
}

.content {
    display: flex;
    flex-direction: row;
    margin: 2rem;
    height: 80%;
    gap: 1rem;
    justify-content: space-evenly;
}

.credit {
    position: fixed;
    top: 1rem;
    right:1rem;
    font-size: 2rem;
    transition: all 0.5s;
}
.credit:hover {
    color: var(--secondary);
    transform: scale(1.2);
}

a:link, a:visited, a:hover, a:active { 
    color: var(--primary);
    text-decoration: none; 
} `, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,qCAAqC;IACrC,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB","sourcesContent":["@import url(./themes.css);\r\n\r\nhtml, body {\r\n    margin: 0px;\r\n    height: 100vh;\r\n}\r\n\r\nbody {\r\n    background-color: var(--background);\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: var(--text);\r\n}\r\n\r\n.title-bar {\r\n    background-color: var(--tiles);\r\n    color:var(--primary);\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-size:3rem;\r\n    padding: 1rem;\r\n    justify-items: center;\r\n    text-align: center;\r\n    font-weight: bolder;\r\n}\r\n\r\n.content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 2rem;\r\n    height: 80%;\r\n    gap: 1rem;\r\n    justify-content: space-evenly;\r\n}\r\n\r\n.credit {\r\n    position: fixed;\r\n    top: 1rem;\r\n    right:1rem;\r\n    font-size: 2rem;\r\n    transition: all 0.5s;\r\n}\r\n.credit:hover {\r\n    color: var(--secondary);\r\n    transform: scale(1.2);\r\n}\r\n\r\na:link, a:visited, a:hover, a:active { \r\n    color: var(--primary);\r\n    text-decoration: none; \r\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
